export const UserRoles = [
  {
    value: "customer",
    label: "customer"
  },
  {
    value: "admin",
    label: "admin"
  },
  {
    value: "super_admin",
    label: "super admin"
  }
];



// WEBPACK FOOTER //
// ./src/constants/UserRoles.js